import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { OCP_DIALOG_REF } from '../dialog-ref.token';

@Component({
  selector: 'ocp-unsupported-file-type-dialog',
  imports: [TranslatePipe, HlmButtonImports],
  templateUrl: './unsupported-file-type-dialog.component.html',
  styleUrl: './unsupported-file-type-dialog.component.scss',
})
export class UnsupportedFileTypeDialogComponent {
  // Opened via HlmDialogService, which does not provide OCP_DIALOG_REF; both are optional.
  private readonly brnDialogRef = inject<BrnDialogRef<unknown>>(BrnDialogRef, { optional: true });
  private readonly dialogRef = inject(OCP_DIALOG_REF, { optional: true });

  protected onClose(): void {
    this.brnDialogRef?.close();
    this.dialogRef?.close();
  }
}
